import { atom, useRecoilState } from "recoil";

export const getAppName = atom({
  key: "getAppName",
  default: "TP",
});

const BulkSitesCreationToggle = () => {
  const [appName, setAppName] = useRecoilState<any>(getAppName);

  const handleAppNameClick = (name: string | null) => {
    setAppName(name);
  };

  const buttonStyle = {
    cursor: "pointer",
    padding: "12px 24px",
    transition: "color 0.3s, transform 0.3s, box-shadow 0.3s",
    marginLeft: "40px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    border: "none",
    backgroundColor: "transparent",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  };

  const activeButtonStyle: any = {
    ...buttonStyle,
    color: "#009cde",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  };

//   const activeUnderlineStyleCS: any = {
//     position: "absolute",
//     left: 0,
//     bottom: 0,
//     width: "100%",
//     height: "2px",
//     backgroundColor: "#009cde",
//     transform: appName === "CS" ? "scaleX(1)" : "scaleX(0)",
//     transformOrigin: "left",
//     transition: "transform 0.3s",
//     zIndex: -1,
//   };
  const activeUnderlineStyleTP: any = {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    height: "2px",
    backgroundColor: "#009cde",
    transform: appName === "TP" ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s",
    zIndex: -1,
  };

  return (
    <div>
      {/* <button
        onClick={() => {
          handleAppNameClick("CS");
        }}
        style={appName === "CS" ? activeButtonStyle : buttonStyle}
      >
        CorporateSight
        <div style={activeUnderlineStyleCS}></div>
      </button> */}
      <button
        onClick={() => {
          handleAppNameClick("TP");
        }}
        style={appName === "TP" ? activeButtonStyle : buttonStyle}
      >
        Tax Portal
        <div style={activeUnderlineStyleTP}></div>
      </button>
    </div>
  );
};

export default BulkSitesCreationToggle;
